// Имя гостя в рамках одной встречи (guest-ссылки): переживает перезаход.
// Identity гостя в LiveKit и спикер в транскрипте — это буквально имя,
// поэтому повторный вход с тем же именем склеивает речь под одним спикером.
const key = (token: string) => `telemost.guest-name:${token}`

export function loadGuestName(token: string): string {
  try {
    return localStorage.getItem(key(token)) ?? ''
  } catch {
    return ''
  }
}

export function saveGuestName(token: string, name: string): void {
  try {
    localStorage.setItem(key(token), name)
  } catch {
    // приватный режим / квота — просто не персистим
  }
}
